import {request} from './request'
const hdkApi ={
  

  //活动列表
  getList:params=>{
    let params2={
      page:params.page?params.page:1,
      pageSize:params.pageSize?params.pageSize:8,
      brand_id:params.brand_id?params.brand_id:-1,
      is_top:params.is_top?params.is_top:-1,
      level:params.level?params.level:-1,
      city:params.city?params.city:'',
      task_year:params.task_year?params.task_year:'',
      keywords:params.keywords || '',
      recommend: params.recommend ? params.recommend : -1,  //是否推荐
      library:params.library || -1,
    }
    return request({url: '/AcitivityApi/GetList',params:params2});
  },

  //单一内容
  getOneById:params=>{
    params._t = Math.floor(Math.random() * 1000000)
    return request({url: '/AcitivityApi/GetById',params:params,});
  },

  getProgramList: params => request({url: '/TProgramlistApi/GetList',params:params})
}

export default hdkApi